import { createRouter, createWebHistory } from "vue-router";
// import Dashboard from "../views/Dashboard.vue";
import Login from "../views/Login.vue";

import Register from "../views/Register.vue";
import ResetPassword from "../views/ResetPassword.vue";
import Cookies from "js-cookie";


const authGuard = (to, from, next) => {
  next(); // allow everything
};


const routes = [
  // { path: "/", name: "login", component: Login },
  { path: "/", redirect: "/dashboard" },
  { path: "/register", name: "Register", component: Register },
  { path: "/login", component: Login },
  {
    path: "/forget",
    name: "Reset Password",
    component: ResetPassword
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Dashboard.vue"),
    beforeEnter: authGuard,
    meta: { title: "Dashboard" },
  },

  {
    path: "/agencies-graphical",
    name: "agencies-graphical",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AgencyGraphical.vue"),
    beforeEnter: authGuard,
    meta: { title: "Agencies" },
  },
  {
    path: "/clients",
    name: "Clients",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Clients.vue"),
    beforeEnter: authGuard,
    meta: { title: "Clients" },
  },


  {
    path: "/accounts-graphical",
    name: "accounts-graphical",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AccountsGraphical.vue"),
    beforeEnter: authGuard,
    meta: { title: "Accounts" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.beforeEach(authGuard);

export default router;
